import { mapState, mapActions } from 'vuex'
import {
  parseISO,
  formatISO,
  addDays,
  subDays,
  startOfMonth,
  subMonths,
  lastDayOfMonth,
  sub,
} from 'date-fns'

export default {
  name: 'Options',
  props: {
    showStats: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > addDays(new Date(), 1) - 8.64e7
        },
      },
      timeFrameOptions: [
        { label: 'Last 7 days', value: 'last7Days' },
        { label: 'Last 30 days', value: 'last30Days' },
        { label: 'This month', value: 'thisMonth' },
        { label: 'Last month', value: 'lastMonth' },
        { label: 'Custom period', value: 'custom' },
      ],
    }
  },
  computed: {
    ...mapState({
      currentCampaignsList: (state) => state.campaign.currentCampaignsList,
      areCampaignsLoaded: (state) => state.campaign.areCampaignsLoaded,
      targetCampaignUUID: (state) => state.campaign.targetCampaignUUID,
      analyticsTimeFrame: (state) => state.campaign.analytics.stats.timeFrame,
    }),
    selectTargetCampaignUUID: {
      get() {
        return this.targetCampaignUUID
      },
      set(uuid) {
        this.getCampaignStats({ uuid })
        this.getCampaignResponses({ uuid })
      },
    },
    pickerDate: {
      get() {
        return [this.analyticsTimeFrame.from, this.analyticsTimeFrame.to]
      },
      set(value) {
        const uuid = this.targetCampaignUUID
        let fromDate = value[0]
        const toDate = value[1]
        const label = 'custom'

        if (toDate === fromDate) {
          fromDate = formatISO(sub(parseISO(fromDate), { days: 1 }), { representation: 'date' })
        }

        this.getCampaignStats({ uuid, toDate, fromDate, label })
      },
    },
    selectTimeFrame: {
      get() {
        return this.analyticsTimeFrame.label
      },
      set(value) {
        const today = new Date()
        const prevMonth = subMonths(today, 1)
        let fromDate = ''
        let toDate = today
        const label = value

        switch (value) {
          case this.timeFrameOptions[0].value: // last7Days
            fromDate = subDays(today, 7)
            break
          case this.timeFrameOptions[1].value: // last30Days
            fromDate = subMonths(today, 1)
            break
          case this.timeFrameOptions[2].value: // thisMonth
            fromDate = startOfMonth(today)
            break
          case this.timeFrameOptions[3].value: // lastMonth
            toDate = lastDayOfMonth(prevMonth)
            fromDate = startOfMonth(prevMonth)
            break
          case this.timeFrameOptions[4].value: // custom
            fromDate = subDays(today, 7)
            break
        }

        toDate = formatISO(today, { representation: 'date' })
        fromDate = fromDate ? formatISO(fromDate, { representation: 'date' }) : ''
        const uuid = this.targetCampaignUUID

        this.getCampaignStats({ uuid, fromDate, toDate, label })
      },
    },
  },
  methods: {
    ...mapActions('campaign/analytics/stats', ['getCampaignStats']),
    ...mapActions('campaign/analytics/responses', ['getCampaignResponses']),
    ...mapActions('campaign/analytics/download', ['downloadCampaignStats']),
    triggerDownloadCSV() {
      const uuid = this.targetCampaignUUID
      const name = this.currentCampaignsList.find((obj) => obj.uuid === uuid).name
      this.downloadCampaignStats({ uuid, name })
    },
  },
}
